<template>
  <div>
    <thingListHeader />
    <thingsFirst />
  </div>
</template>

<script>
  import thingListHeader from "../../components/Pages/Things/Headers/thingsList/thingListHeader";
  import thingsFirst from "../../components/Pages/Things/Things/thingFirstLevel";
  import {mapState, mapMutations} from 'vuex'
  import {tokenAndRoute} from "../../mixins/utils/tokenAndRoute";

  export default {
    name: "ThingsInProject",
    mixins: [tokenAndRoute],
    components: {thingListHeader, thingsFirst},
    computed: {
      ...mapState({
        projects: state => state.projects.allProjects
      }),
      itemName() {
        let name;
        const id = this.$route.params.item;

        for (let project of this.projects) {
          if (!name) {
            findName(project.items);
          };
        };

        return name;

        function findName(arr) {
          findItem(arr);

          function findItem(a) {
            for (let item of a) {
              if (item.id == id) {
                name = item.name;
                break;
              } else {
                findItem(item.items);
              }
            }
          }
        }
      }
    },
    methods: {
      ...mapMutations({
        setFullSidebar: 'sidebar/SET_DASHBOARD',
        setLinkName: 'sidebar/SET_LINK_NAME',
        setRouteName: 'sidebar/SET_ROUTE_NAME'
      })
    },
    watch: {
      routeItem(val) {
        if (val) {
          this.setRouteName(this.itemName);
        }
      }
    },
    beforeRouteEnter(to,from,next) {
      next(vm => {
        vm.setFullSidebar(false);
        vm.setLinkName('projectItemThings');
        vm.setRouteName(vm.itemName);
      })
    },


  }
</script>

<style lang="scss" scoped>
</style>
